<script>
import TableRow from '@/components/order/TableRow';
import RooshTable from '@/components/common/RooshTable';

export default {
  name: 'order-table',
  extends: RooshTable,
  props: {
    headers: {
      type: Array,
      default: () => [
        'order_reference',
        'from',
        'to',
        'license_plate',
        'name',
        'status',
        'controls',
      ],
    },
    tableRowComponent: {
      type: Object,
      default: () => TableRow,
    },
    translationPrefix: {
      type: String,
      default: 'order',
    },
  },
}
</script>
